import { useState, useMemo } from 'react';

export const useCampaignSearch = (campaigns) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCampaigns = useMemo(() => {
    if (!searchTerm.trim()) {
      return campaigns;
    }

    const searchLower = searchTerm.toLowerCase();

    return campaigns.filter(
      (campaign) =>
        campaign.CampaignName.toLowerCase().includes(searchLower) ||
        campaign.CampaignId.toString().includes(searchLower) ||
        campaign.Employees.some(
          (employee) =>
            employee.EmployeeName.toLowerCase().includes(searchLower) ||
            employee.EmployeeId.toString().includes(searchTerm) ||
            (employee.EmployeeRegion &&
              employee.EmployeeRegion.toLowerCase().includes(searchLower)),
        ),
    );
  }, [campaigns, searchTerm]);

  const clearSearch = () => setSearchTerm('');

  return {
    searchTerm,
    setSearchTerm,
    filteredCampaigns,
    clearSearch,
  };
};
